<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="EBook-Break" id="_idParaDest-9"> </p>
<p class="PN">P<span class="Part _idGenCharOverride-1">ART</span> 1</p>
<p class="PT">“And All the<br/>Devils Are Here”</p>
<p class="PTYear">1862</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook43518.vue?0093646a